<nz-modal *ngIf="isVisible" [(nzVisible)]="isVisible" [nzTitle]="title" [nzStyle]="{ top: '50px' }" (nzOnCancel)="close()" [nzWidth]="1000">
  <ng-container *nzModalContent>
    <div id="canavs" style="height: 80vh"></div>
  </ng-container>
  <div *nzModalFooter></div>
</nz-modal>
